import * as d3 from 'd3';

export default class ZoomPlugin {
    init() {
        const height = this.parent.height;

        this.selector = this.parent.canvas.select('.js-indicators').append('rect')
            .attr('width', '0')
            .attr('height', height)
            .attr('class', 'zoom')
        ;
        this.zoomX = 0;
        this.isZooming = false;
    }

    setParent(parent) {
        this.parent = parent;
    }

    onDoubleClick() {
        this.parent.reset();
    }

    onMouseDown(event) {
        this.zoomX = event.x;
        this.isZooming = true;
    }

    onMouseUp(event) {
        if (!this.isZooming) {
            return false;
        }

        this.isZooming = false;
        this.selector.attr('width', '0');

        const x = this.parent.x;
        const zoomX = this.zoomX;
        const mouseX = event.x;
        const diff = Math.abs(zoomX - mouseX);

        if (diff < 50) {
            return false;
        }

        const left = d3.min([zoomX, mouseX]);
        const right = d3.max([zoomX, mouseX]);

        const leftBound = Math.floor(this.parent.scopedData.length * ((left) / this.parent.chartRwdWidth));
        const rightBound = Math.ceil(this.parent.scopedData.length * ((right) / this.parent.chartRwdWidth));

        if (Math.abs(leftBound - rightBound) < 2) {
            return false;
        }

        const data = this.parent.scopedData.slice(leftBound, rightBound);

        x.domain([0, data.length-1]);

        if (data.length > 5) {
            const firstTick = Math.floor(data.length / 3)
            const secondTick = firstTick * 2;

            this.parent.axisX.call(
                d3.axisBottom(this.parent.x)
                    .tickValues([0, firstTick, secondTick, data.length-1])
                    .tickFormat((index) => data[index].hint.data )
            );
        } else {
            this.parent.axisX.call(
                d3.axisBottom(this.parent.x)
                    .tickValues([0, data.length-1])
                    .tickFormat((index) => data[index].hint.data )
            );
        }

        this.parent.narrow(leftBound, rightBound);
    }

    onMouseMove(event) {
        if (!this.isZooming) {
            return false;
        }

        const mouseX = event.x;
        const zoomX = this.zoomX;
        const diff = mouseX - zoomX;
        
        if (diff > 0) {
            this.selector.attr('transform', 'matrix(1, 0, 0, 1, ' + zoomX/this.parent.zoomRatio + ', 0)');
        } else {
            this.selector.attr('transform', 'matrix(1, 0, 0, 1, ' + mouseX/this.parent.zoomRatio + ', 0)');
        }

        this.selector.attr('width', Math.abs(diff/this.parent.zoomRatio));
    }

}


// WEBPACK FOOTER //
// ./js/Plugins/ZoomPlugin.js